export default __webpack_public_path__ + "static/media/04.16a455c1.webp";